import MoreLikeThisSection from './MoreLikeThisSection'

export default MoreLikeThisSection
